<template>
  <Modal v-model="modal" :title="$t('secondaryPassword.VALIDATE')" footer-hide>
    <verification-code
      ref="verificationCodeRef"
      @complete="onValidatePassword"
    />
    <div style="margin-top: 20px">
      <a @click="handleForgetPassword">
        {{ $t('secondaryPassword.forgetPassword') }}
      </a>
    </div>
  </Modal>
</template>
<script>
import VerificationCode from './VerificationCode.vue';

export default {
  components: { VerificationCode },
  data() {
    return {
      modal: false,
      action: null
    };
  },
  methods: {
    onOpen(action) {
      this.modal = true;
      this.action = action;
      this.$refs.verificationCodeRef.clear();
    },
    handleForgetPassword() {
      this.$Message.error(this.$t('secondaryPassword.forgetPasswordText'));
    },
    //验证密码
    async onValidatePassword(password) {
      try {
        const { data } = await this.$http(
          'get',
          'mobile/payroll_secondary_password/validate',
          {
            password
          },
          true
        );
        if (!data) {
          this.$Message.error(this.$t('secondaryPassword.passwordError'));
          this.$refs.verificationCodeRef.clear();
        } else {
          sessionStorage.setItem('secondaryPassword', password);
          this.$emit('complete', this.action);
          this.modal = false;
        }
      } catch (e) {}
    }
  }
};
</script>
<style scoped lang="less"></style>
